import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOutboundTenderList extends Layout {
    buttonAdditionalInfo: Button;
    panel1: Panel;
    sourceEdiOrder: DataSource;
    sourceEdiorderProfile: DataSource;
    tableOutboundTenders: Table;
}
